import { render } from "./transferPop.vue?vue&type=template&id=6a56bc65&scoped=true"
import script from "./transferPop.vue?vue&type=script&lang=js"
export * from "./transferPop.vue?vue&type=script&lang=js"

import "./transferPop.vue?vue&type=style&index=0&id=6a56bc65&scoped=true&lang=scss"

import exportComponent from "D:\\JYC\\产品源码\\前端\\工作流引擎\\stgd.oa.mobile.h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a56bc65"]])

export default __exports__